const getState = () => ({
  modalVisible: false,
  modalStatus: 'DEFAULT', // DEFAULT, SUCCESS, ERROR
  formStatus: 'DEFAULT', // DEFAULT, SUCCESS, ERROR
});

export default Object.assign(getState(), { getState: getState });
